// extracted by mini-css-extract-plugin
export default {"root":"multi-actions_root__EwHOw","content":"multi-actions_content__ev+ze"};